<div [formGroup]="form" class="ovrrride-flange-input-wrap">
    <mat-label class="font-style" [ngbTooltip]="y_tooltip" placement="right" container="body" tooltipClass="custom-tooltip"> Y </mat-label>
    <!--tool-tip template start-->
    <ng-template #y_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.Y' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->

    <div class="example-checkbox" [ngClass]="form.get('y').valid ? '' : 'highLight'">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" formControlName="isy"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input matInput formControlName="y" name="y" [readonly]="!form.get('isy').value" />
        </mat-form-field>
    </div>
</div>
